import useCommentsDraftSession from "./comments-use-draft-session";

const CommentsHooks = {
    draftSession: useCommentsDraftSession,
};

export default CommentsHooks;
